import React, { useState } from 'react';
import DemoBanner from '../../components/DemoBanner';
import SafeIcon from '../../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiMessageSquare, FiArrowRight, FiCheckCircle } = FiIcons;

const GesprekTrainer = () => {
  const [activeQuestion, setActiveQuestion] = useState(0);
  const questions = [
    "Vertel eens wat over jezelf?",
    "Waarom wil je bij dit bedrijf werken?",
    "Wat zijn je sterke en zwakke punten?",
    "Beschrijf een situatie waarin je onder druk moest presteren?",
    "Waarom ben jij de beste kandidaat voor deze rol?"
  ];

  return (
    <div className="min-h-screen py-16 bg-gray-50">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <DemoBanner />
        <div className="text-center mb-12">
          <h1 className="text-4xl font-bold text-brand-dark mb-4">Gesprekstraining</h1>
          <p className="text-gray-600">Deze tool werkt direct in je browser. Geen account. Geen kosten. Geen data-opslag.</p>
        </div>

        <div className="bg-white rounded-3xl border border-gray-200 overflow-hidden shadow-sm">
          <div className="p-8 bg-brand-dark text-white text-center">
            <span className="text-sm font-bold opacity-60 uppercase tracking-widest">Vraag {activeQuestion + 1} van {questions.length}</span>
            <h2 className="text-2xl font-bold mt-4">{questions[activeQuestion]}</h2>
          </div>
          
          <div className="p-8">
            <div className="bg-blue-50 p-6 rounded-2xl border border-blue-100 mb-8">
              <h3 className="font-bold text-blue-900 mb-2 flex items-center gap-2">
                <SafeIcon icon={FiCheckCircle} /> Tip van de AI
              </h3>
              <p className="text-blue-800">Gebruik voor deze vraag de STAR-methode (Situatie, Taak, Actie, Resultaat). Focus op concrete voorbeelden.</p>
            </div>

            <textarea 
              className="w-full h-48 p-4 border rounded-xl outline-none focus:ring-2 focus:ring-brand-orange mb-6"
              placeholder="Typ hier je antwoord om te oefenen..."
            />

            <div className="flex justify-between items-center">
              <button 
                onClick={() => setActiveQuestion(Math.max(0, activeQuestion - 1))}
                className="text-gray-400 font-bold hover:text-brand-dark transition-colors"
                disabled={activeQuestion === 0}
              >
                Vorige
              </button>
              <button 
                onClick={() => setActiveQuestion(Math.min(questions.length - 1, activeQuestion + 1))}
                className="px-8 py-3 bg-brand-orange text-white rounded-xl font-bold hover:bg-orange-600 transition-all flex items-center gap-2 shadow-lg"
              >
                Volgende vraag <SafeIcon icon={FiArrowRight} />
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default GesprekTrainer;